module.exports = __webpack_public_path__ + "img/DragonStorm_EGM.950df07b.png";